module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-turntable"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.truntable.activityBackgroundAfter,
      "alt": ""
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "warp"
  }, [_c('img', {
    attrs: {
      "src": _vm.truntable.couponPicture,
      "alt": ""
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "telephone"
  }, [_c('ul', [_c('li', [_c('section', {
    staticClass: "phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "number",
      "placeholder": "请输入电话号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "code"
  }, [_c('dl', [_c('dt', [_c('section', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('button', {
    staticClass: "code_button",
    on: {
      "click": _vm.getVerificationCode
    }
  }, [_c('span', [_vm._v("获取验证码")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "button"
  }, [_c('section', {
    style: (_vm.styleButton),
    on: {
      "click": _vm.handleReceive
    }
  }, [_vm._v("\n            立即领取\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d57ff00","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activityTurntableAfter.vue
// module id = 319
// module chunks = 1